<script setup>
import { ref, onMounted, onBeforeUnmount, h, render } from "vue";

const props = defineProps({
  component: {
    type: Object,
    required: true
  },
  props: {
    type: Object,
    default: () => ({})
  }
});

const container = ref(null);

onMounted(() => {
  container.value = document.createElement("div");
  const vnode = h(props.component, props.props);
  render(vnode, container.value);
  document.body.appendChild(container.value);
});

onBeforeUnmount(() => {
  if (container.value) {
    render(null, container.value);
    document.body.removeChild(container.value);
    container.value = null;
  }
});
</script>

<template>
  <slot></slot>
</template>
